import styled from 'react-emotion'

import Colors from '../../../themes/Colors'
import { Typo24WhiteNBI } from '../../../themes/Fonts/Nort'
import { mobile, customDevice, maxDeviceWidth } from '../../../utils/mixins'
import {
  Typo14PinkishGreyDI,
  Typo14PumpkinOrangeDBI
} from '../../../themes/Fonts/Din2014'

import CloudinaryS3LazyLoadedImage from '../../CloudinaryS3LazyLoadedImage'

export const SectionContainer = styled('section')`
  background-color: ${Colors.blackDefault};
  padding-top: 60px;
  padding-bottom: 60px;
  ${mobile} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

export const SectionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`

export const CardsWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 30px;
  ${maxDeviceWidth(1024)} {
    justify-content: space-around;
  }
`

export const CardWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 350px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 30px;
  :nth-child(3n) {
    margin-right: 0px;
  }
  ${customDevice(320, 350)} {
    width: 95%;
    margin-right: 0px;
  }
  ${mobile} {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 0px;
    width: 100%;
  }
  ${customDevice(768, 1024)} {
    margin-right: 0px;
    width: 336px;
  }
`

export const Image = styled(CloudinaryS3LazyLoadedImage)`
  height: 214px;
  ${mobile} {
    height: 211px;
  }
`
export const Heading = styled(Typo24WhiteNBI)`
  line-height: normal;
  letter-spacing: 0.5px;
  margin: 10px 0 20px 0;
  ${mobile} {
    font-size: 22px;
    margin: 8px 0 10px 0;
  }
`

export const Description = styled(Typo14PinkishGreyDI)`
  line-height: 1.57;
  letter-spacing: normal;
  margin-bottom: 10px;
  ${mobile} {
    line-height: 1.5;
    color: ${Colors.whiteEight};
  }
`

export const ReadMore = styled(Typo14PumpkinOrangeDBI)`
  line-height: normal;
  letter-spacing: 0.5px;
  ${mobile} {
    line-height: 1.5;
    font-weight: normal;
  }
  :hover {
    color: ${Colors.pumpkinOrange};
    text-decoration: none;
  }
  :active {
    color: ${Colors.pumpkinOrange};
    text-decoration: none;
  }
  :focus {
    color: ${Colors.pumpkinOrange};
    text-decoration: none;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PortfolioSection/styledComponents.js